import { render, staticRenderFns } from "./AddOrganization.vue?vue&type=template&id=67ba341f&scoped=true&"
import script from "./AddOrganization.vue?vue&type=script&lang=js&"
export * from "./AddOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ba341f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67ba341f')) {
      api.createRecord('67ba341f', component.options)
    } else {
      api.reload('67ba341f', component.options)
    }
    module.hot.accept("./AddOrganization.vue?vue&type=template&id=67ba341f&scoped=true&", function () {
      api.rerender('67ba341f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/AdminPage/OrganizationsPage/AddOrganization.vue"
export default component.exports